export function isDateField(field_type: string) {
  if (field_type == 'date') {
    return true;
  }
  return false;
}

function isValidDate(d: any) {
  return d instanceof Date && !isNaN(d.getTime());
}
